import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["tab-index", "aria-label", "disabled", "onKeydown", "onKeyup"]

import { computed } from 'vue';

import { ISecondButtonProps } from '@/@types/components/ui/buttons';

import '@/components/ui/buttons/SmSecondButton/style.scss';

// [START] Props

export default /*#__PURE__*/_defineComponent({
  __name: 'SmSecondButton',
  props: {
    disabled: { type: Boolean, default: false },
    tabIndex: { default: 0 },
    ariaLabel: { default: null }
  },
  emits: ["click", "keydown.enter", "keydown.space"],
  setup(__props: any, { emit: emits }) {

const props = __props;


// [END] Props

// [START] Emits

// [END] Emits

// [START] Computed
const ariaLabel = computed((): string => props.ariaLabel || '');
// [END] Computed

// [START] Methods
const handleClick = (): void => emits('click');
const handleKeyDownEnter = (): void => emits('keydown.enter');
const handleKeyUpSpace = (): void => emits('keydown.space');
// [END] Methods

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "second-button",
    "tab-index": props.tabIndex,
    "aria-label": ariaLabel.value,
    disabled: props.disabled,
    role: "button",
    onClick: handleClick,
    onKeydown: _withKeys(handleKeyDownEnter, ["enter"]),
    onKeyup: _withKeys(handleKeyUpSpace, ["space"])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 40, _hoisted_1))
}
}

})